import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { Fragment, memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import AccordionCohabitantForm from './form';
import { ResolutionFactoCohabitationFormVM } from 'mutation/view-models/resolution-facto-cohabitation';

const AccordionCohabitantComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<ResolutionFactoCohabitationFormVM>();

  const onFieldPersonChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('cohabitant', {
        ...formContext.values.cohabitant,
        [key]: value,
      });
    },
    [formContext.values.cohabitant, formContext.setFieldValue]
  );

  const onFieldsPersonChange = useCallback(
    (values, convivente) => {
      formContext.setValues({
        ...formContext.values,
        convivente: convivente,
        cohabitant: {
          ...(values || {}),
        },
      });
    },
    [formContext.values.cohabitant, formContext.setFieldValue]
  );

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-cohabitant-content"
          id="panel-cohabitant-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Dati convivente</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionCohabitantForm
            disabled
            values={formContext.values.cohabitant}
            setFieldValue={formContext.setFieldValue}
            onChange={onFieldPersonChange}
            onChangeValues={onFieldsPersonChange}
            idFamilyIstat={formContext.values.idFamilyIstat}
            idFamilyMunicipality={formContext.values.idFamilyMunicipality}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionCohabitantComponent.displayName = 'Accordion cohabitant component';

const AccordionCohabitant = memo(AccordionCohabitantComponent);

export default AccordionCohabitant;
